import { render } from "./AccountRoot.vue?vue&type=template&id=31e0ad57"
import script from "./AccountRoot.vue?vue&type=script&lang=js"
export * from "./AccountRoot.vue?vue&type=script&lang=js"

import "./AccountRoot.vue?vue&type=style&index=0&id=31e0ad57&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__